import { api } from "./client";
import type { Me } from "@/stores/auth";

export const authApi = {
  login: (email: string, password: string) =>
    api.post<{ access_token: string; token_type: string }>("/auth/login", { email, password }),
  refresh: () => api.post<{ access_token: string }>("/auth/refresh"),
  logout: () => api.post<{ status: string }>("/auth/logout"),
  me: () => api.get<Me>("/auth/me"),
  updateMe: (payload: {
    full_name?: string;
    avatar_attachment_id?: string;
    clear_avatar?: boolean;
  }) => api.patch<Me>("/auth/me", payload),
};
